import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { bridgeDescriptor } from './descriptor.js';

export const bridgeCatalogEntry = {
  descriptor: bridgeDescriptor,
  availability: 'production',
  load: async () => (await import('./game.js')).bridgeGeneratorDefinition,
} satisfies AvailableGameCatalogEntry;
